import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {

  constructor(private swUpdate: SwUpdate, private _translation: TranslateService) {
    swUpdate.available.subscribe(event => {
      if (window.confirm(`${this._translation.instant('update.service')}`)) {
        swUpdate.activateUpdate().then(() => document.location.reload());
      }
    });
  }

  checkForUpdates() {
    this.swUpdate.checkForUpdate();
  }
}
